import { render, staticRenderFns } from "./view-activation.vue?vue&type=template&id=238e85ac&"
import script from "./view-activation.vue?vue&type=script&lang=ts&"
export * from "./view-activation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports